export function scrollSmoothHandler(div){
  div.current.scrollIntoView({ behavior: 'smooth' });
};
